/* eslint-env browser */
/* eslint react/prop-types:0 */
import * as React from 'react'
const { captureException } = require('../services/sentry-service')

const Counterpart = require('@gandi/counterpart').Instance

const translate = new Counterpart()
translate.registerTranslations('en', require('./i18n/en.json'))
translate.registerTranslations('fr', require('./i18n/fr.json'))

translate.setFallbackLocale('en')

translate.onTranslationNotFound((locale, key, fallback, scope) => {
  if (['fr', 'en'].includes(locale)) {
    captureException(new Error(`missing translation: ${locale} ${key}`))
    console.warn(`missing translation: ${locale} ${key}`)
  }
})
translate.setMissingEntryGenerator(key => key)

const withTranslator = WrappedComponent =>
  class extends React.Component {
    constructor() {
      super()
      this.state = {}
      this.doTranslate = this.doTranslate.bind(this)
    }

    doTranslate(key, opts = {}) {
      let { locale } = this.props
      if (!locale) {
        const err = new Error(`Tried to use TranslatorProvider without a locale ? ${WrappedComponent.name}`)

        captureException(err)
        console.error(err)
        locale = 'en'
      }
      ;[locale] = locale.split('-')
      return translate.translate(key, { locale, ...opts })
    }

    render() {
      return <WrappedComponent translate={this.doTranslate} {...this.props} />
    }
  }

export const useTranslator = locale => {
  return React.useCallback(
    (key, opts = {}) => {
      return translate.translate(key, { locale, ...opts })
    },
    [locale]
  )
}

export default withTranslator
export const translateFunc = translate.translate
